import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { BlockUIModule } from 'primeng/blockui';

import { PageHeaderComponent } from './page-header/page-header.component';
import { PageNavbarComponent } from './page-navbar/page-navbar.component';
import { BaseLayoutComponent } from './base-layout/base-layout.component';
import { UnauthenticatedLayoutComponent } from './unauthenticated-layout/unauthenticated-layout.component';
import { BaseNavLayoutComponent } from './base-nav-layout/base-nav-layout.component';
import { DefaultLayoutComponent } from './default-layout/default-layout.component';
import { PageInfoService } from './page-info.service';
import { FeedbackComponent } from './feedback/feedback.component';
import { FeedbackService } from './feedback/feedback.service';
import { AuthInterceptor } from '../authentication/auth-interceptor';

@NgModule({
	declarations: [
		PageHeaderComponent,
		PageNavbarComponent,
		BaseLayoutComponent,
		UnauthenticatedLayoutComponent,
		BaseNavLayoutComponent,
		DefaultLayoutComponent,
		FeedbackComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		DialogModule,
		ToastModule,
		BlockUIModule
	],
	exports: [
		BaseLayoutComponent,
		UnauthenticatedLayoutComponent,
		BaseNavLayoutComponent,
		DefaultLayoutComponent
	],
	providers: [
		PageInfoService,
		FeedbackService,
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
	]
})
export class LayoutsModule { }